import { Box, useFormControlContext } from '@chakra-ui/react';
import * as React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// If you use the component directly from 'react-datepicker' you can specify
// the boolean "selectsRange" property and the type of the "onChange" prop will
// automatically change to be correct. I couldn't figure out how to get it to
// work for our customized component though, so I just created a second
// export for selecting a range. Not ideal but should work for now

export type DatePickerProps = ReactDatePickerProps<never, false>;

const sx = {
  '.react-datepicker-popper': {
    zIndex: 'docked',
  },
};

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  const formControlContext = useFormControlContext();
  const anyDisabled = props.disabled || formControlContext?.isDisabled;

  return (
    <Box sx={sx} w="full">
      <ReactDatePicker {...props} disabled={anyDisabled} />
    </Box>
  );
};

DatePicker.defaultProps = {
  dateFormat: 'h:mm a EEEE, MMMM d yyyy',
};

export type RangeDatePickerProps = ReactDatePickerProps<never, true>;

export const RangeDatePicker: React.FC<RangeDatePickerProps> = (props) => {
  const formControlContext = useFormControlContext();
  const anyDisabled = props.disabled || formControlContext?.isDisabled;

  return (
    <Box sx={sx} w="full">
      <ReactDatePicker {...props} selectsRange={true} disabled={anyDisabled} />
    </Box>
  );
};

RangeDatePicker.defaultProps = {
  dateFormat: 'h:mm a EEEE, MMMM d yyyy',
};
